import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';
import { CashierPreferences } from 'src/common/interfaces/dtos/CashierPreferences';
import ZoomLevelSizes from 'src/preferences/components/zoom-level-sizes/zoom-level-sizes';

const ZoomLevelPreferences: React.FC<ZoomLevelPreferencesProps> = (props): JSX.Element => {
  const { userPreferences, updatePreferences } = props;
  const [zoomLevel, setZoomLevel] = useState<SizeType>(
    userPreferences.textZoomLevel && userPreferences.buttonZoomLevel,
  );

  useEffect(() => {
    updatePreferences('textZoomLevel', zoomLevel);
  }, [zoomLevel, updatePreferences]);

  useEffect(() => {
    updatePreferences('buttonZoomLevel', zoomLevel);
  }, [zoomLevel, updatePreferences]);

  return (
    <Grid>
      <ZoomLevelSizes zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} />
    </Grid>
  );
};

interface ZoomLevelPreferencesProps {
  userPreferences: CashierPreferences;
  updatePreferences: (prefName: string, newValue: any) => void;
}

export default ZoomLevelPreferences;
